import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import Filter from 'views/agent/reports/balanceTransactionReport/filter'; // Importing Filter component
import Table from 'views/agent/reports/balanceTransactionReport/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the balance transaction report view.
 * @extends JetView
 */
export default class balanceTransactionReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            type: 'wide',
            rows: [], // Placeholder for future rows
        };
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Reporte de transacciones del saldo'), // Filename for the export
                                    ignore: {
                                        detailTittle: true,
                                        Action: true,
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de transacciones del saldo'), // Filename for the export
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            Action: true,
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        {
                            view: 'label',
                            label: _('Reporte de transacciones del saldo'), // Title label
                        },
                    ],
                },
                Filter, // Filter component
                Table, // Table component
                toolbar, // Toolbar component
            ],
        };
        const avanc = {
            view: 'accordion', // Accordion for advanced details
            multi: true,
            collapsed: true,
            cols: [{ header: _('Detalles Avanzados'), body: right }],
        };
        const avancResp = {
            view: 'accordion', // Responsive accordion for advanced details
            multi: true,
            collapsed: true,
            id: 'carousel1',
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'), // Header for advanced details
                    body: right,
                    minWidth: 250,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                } else {
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)', // Adjust scroll position
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };
        return {
            id: 'a5',
            type: 'clean',
            view: 'form', // Main form view
            scrollY: screen.width < 820 ? false : true, // Conditional scroll
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left section with components
                },
            ],
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Webix ready function
            if (screen.width < 500) {
                // Placeholder for future responsive behavior
            }
        });
    }
}

// FILE DOCUMENTED
